import { render, staticRenderFns } from "./PageEditorSectionPanel.vue?vue&type=template&id=191074fc&scoped=true"
import script from "./PageEditorSectionPanel.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191074fc",
  null
  
)

export default component.exports